export default "__VITE_ASSET__CBZZV$uB__"